// Entry: esbuild bundles from here into dist/mekaniko.js (IIFE).
// Screens and overlays register their buttons when they are imported.
import { resize } from './ui/state';
import { frame } from './ui/render';
import { devJump } from './ui/dev';
import { applyHtml } from './core/i18n';
import './ui/hud';
import './ui/input';
import './ui/play';
import './ui/intro';
import './ui/title';
import './ui/profiles';
import './ui/creator';
import './ui/map';
import './ui/win';
import './ui/credits';
import './ui/gate';
import './ui/parent-panel';

// ---------- Start ----------
applyHtml();   // texts in index.html and <html lang> in the current language
resize();
requestAnimationFrame(frame);
devJump();
